import { Anchor } from "@twilio-paste/core/anchor";
import { Box } from "@twilio-paste/core/box";
import { Column, Grid } from "@twilio-paste/core/grid";
import { Text } from "@twilio-paste/core/text";
import { ArrowForwardIcon } from "@twilio-paste/icons/esm/ArrowForwardIcon";
import React, { useState } from "react";
import { SlantedBackgroundGradient } from "../../../shared/components/SlantedBackgroundGradient";

const SITE_CONTENT_MAX_WIDTH = "1440px";

const LearnMore: React.FC = () => {
    const [hovered, setHovered] = useState(false);

    const handleMouseEnter = (): void => {
        setHovered(true);
    };
    const handleMouseLeave = (): void => {
        setHovered(false);
    };

    return (
        <Box as="span" display="flex" alignItems="center">
            <Anchor
                href="https://www.twilio.com/docs/flex/developer/plugins"
                variant="inverse"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                Learn more about Flex Plugins
            </Anchor>
            <Box
                as="span"
                display="flex"
                transform={hovered ? "translateY(1px) translateX(4px)" : "translateY(1px) translateX(0)"}
                transition="all 100ms ease"
            >
                <ArrowForwardIcon decorative display="inline-block" size="sizeIcon40" />
            </Box>
        </Box>
    );
};

const HomeHero: React.FC = () => (
    <Box
        paddingX={["space90", "space90", "space180"]}
        paddingTop={["space90", "space90", "space200"]}
        paddingBottom={["space90", "space90", "space160"]}
        position="relative"
    >
        <SlantedBackgroundGradient
            skewAngle={0}
            startColor="colorBackgroundBrandStrong"
            endColor="colorBackgroundBrand"
        >
            <Box maxWidth={SITE_CONTENT_MAX_WIDTH} marginLeft="auto" marginRight="auto" position="relative">
                <Grid vertical={[true, true, false]}>
                    <Column span={[12, 12, 5]}>
                        <Text
                            as="h1"
                            color="colorTextInverse"
                            fontSize={["fontSize90", "fontSize90", "fontSize110"]}
                            lineHeight={["lineHeight90", "lineHeight90", "lineHeight110"]}
                            marginTop={["space80", "space80", "space120"]}
                        >
                            Customize Flex User Interface with UI programmability API&apos;s and Plugins.
                        </Text>
                        <Text
                            as="div"
                            color="colorTextInverse"
                            fontSize="fontSize40"
                            fontWeight="fontWeightBold"
                            lineHeight="lineHeight40"
                            marginTop="space120"
                        >
                            <LearnMore />
                        </Text>
                    </Column>
                    <Column span={7} height="100%" />
                </Grid>
            </Box>
        </SlantedBackgroundGradient>
    </Box>
);

export { HomeHero };
